import styled from 'styled-components';
export var Centered = styled.div.withConfig({
  displayName: "Centered",
  componentId: "sc-r82esg-0"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);